import { useScale } from 'shared/hooks/useScale';
import { calcTextScale } from './calcUtils';
export const useTextScale = (containerRef, props) => {
    return useScale(calcTextScale, containerRef, props);
};
